import { Component } from "@angular/core";
import { ThemeService } from "src/app/services/theme/theme.service";
import { AppConstants } from "src/app/shared/constants/app.contants";
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})


export class HomeComponent  {

  constructor(private themeService: ThemeService) {
   /*if(localStorage.getItem(AppConstants.Session.THEME) == null ||
      localStorage.getItem(AppConstants.Session.THEME) == ""){
      var enterpriseId = localStorage.getItem(AppConstants.Session.ENTERPRISE);
      alert("enterprise  "+enterpriseId);
      this.themeService.getTheme(parseInt(enterpriseId)).subscribe((response2 => {
        if(response2.theme != null){
          localStorage.setItem(AppConstants.Session.THEME, JSON.stringify(response2.theme));
        }
      }));
    }*/
  }
}
